import { IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useMobileDetect } from '../../../hooks';

export const BackButtonFL = ({ handleGoBack }) => {
    const isMobile = useMobileDetect();

    return (
        <>
            <IconButton onClick={handleGoBack} sx={{ color: isMobile ? 'var(--menu-text-color)' : 'var(--primary-color)' }}>
                <ArrowBackIosNewIcon />
            </IconButton>
        </>
    );
};
